import { configureStore } from '@reduxjs/toolkit';
import gamicReducer from '@/store/Gamic';
import userReducer from '@/store/User';
import adminReducer from '@/store/Admin';
import ticketReducer from '@/store/Ticket';
import campaignReducer from '@/store/Campaign';

export const store = configureStore({
  reducer: {
    gamics: gamicReducer,
    users: userReducer,
    admin: adminReducer,
    tickets: ticketReducer,
    campaign: campaignReducer,
  },
});

export type RootState  = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

// 👉 allow `import store from "@/redux/store"`
export default store;
